var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalculator(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3885",
    "data-name": "Rectangle 3885",
    width: 18.884,
    height: 18.884,
    fill: "#495584",
    stroke: "#495584",
    strokeWidth: 0.3
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13244",
    "data-name": "Group 13244",
    transform: "translate(0 0.466)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3886",
    "data-name": "Rectangle 3886",
    width: 24,
    height: 24,
    transform: "translate(0 -0.466)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13243",
    "data-name": "Group 13243",
    transform: "translate(2.558 2.558)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13242",
    "data-name": "Group 13242",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42374",
    "data-name": "Path 42374",
    d: "M18.884,1.7V17.187a1.267,1.267,0,0,0-.038.122,1.958,1.958,0,0,1-1.919,1.573q-7.485,0-14.97,0A1.951,1.951,0,0,1,0,16.925Q0,9.44,0,1.955A1.917,1.917,0,0,1,.637.516,2.226,2.226,0,0,1,1.7,0H17.187a.871.871,0,0,0,.1.036,1.946,1.946,0,0,1,1.5,1.329c.039.108.062.222.093.333m-.8,7.336c0-.069.009-.123.009-.177q0-3.4,0-6.8a1.542,1.542,0,0,0-.042-.383A1.172,1.172,0,0,0,16.806.79q-3.383,0-6.767,0H9.854V9.032ZM.79,9.028H9.028V.8c-.062,0-.11-.007-.158-.007q-3.411,0-6.822,0a1.521,1.521,0,0,0-.383.042A1.173,1.173,0,0,0,.79,2.082q0,3.374,0,6.748v.2m8.239,9.066V9.855H.8c0,.061-.008.11-.008.158q0,3.411,0,6.822a1.526,1.526,0,0,0,.042.383,1.169,1.169,0,0,0,1.229.875q3.392,0,6.785,0h.181m9.065-8.239H9.856v8.231c.061,0,.11.008.158.008q3.411,0,6.822,0a1.522,1.522,0,0,0,.382-.043,1.166,1.166,0,0,0,.875-1.229q0-3.392,0-6.785v-.18",
    transform: "translate(0 0.001)",
    fill: "#495584",
    stroke: "#495584",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42375",
    "data-name": "Path 42375",
    d: "M249.514,95.82c.51,0,1.02,0,1.531,0a.394.394,0,1,1,.019.786q-1.549.008-3.1,0a.394.394,0,1,1,.018-.786c.51,0,1.02,0,1.531,0",
    transform: "translate(-235.351 -91.098)",
    fill: "#495584",
    stroke: "#495584",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42376",
    "data-name": "Path 42376",
    d: "M58.293,66.135c0,.366,0,.709,0,1.052a1.034,1.034,0,0,1-.009.184.4.4,0,0,1-.79-.072c-.007-.313,0-.627,0-.94v-.224h-.913c-.092,0-.185,0-.276-.005a.392.392,0,0,1,.026-.783c.38,0,.76,0,1.164,0,0-.349,0-.685,0-1.02,0-.37.143-.567.409-.56s.392.195.392.558c0,.331,0,.663,0,1.022h.756c.141,0,.283,0,.424,0a.376.376,0,0,1,.383.367.366.366,0,0,1-.355.41c-.325.016-.651.008-.977.011h-.232",
    transform: "translate(-53.171 -60.624)",
    fill: "#495584",
    stroke: "#495584",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42377",
    "data-name": "Path 42377",
    d: "M65.914,256.954l.859.853a.408.408,0,0,1,.152.392.391.391,0,0,1-.671.2c-.258-.246-.5-.5-.757-.754-.042-.042-.088-.081-.148-.137-.3.3-.589.6-.889.891a.392.392,0,1,1-.532-.575l.728-.731c.043-.043.083-.088.147-.155l-.724-.711c-.061-.06-.124-.119-.181-.183a.374.374,0,0,1,0-.544.369.369,0,0,1,.556-.006c.3.292.584.6.9.92l.61-.621c.095-.1.188-.194.287-.286a.392.392,0,1,1,.557.55c-.26.27-.528.531-.793.8-.026.026-.05.054-.1.105",
    transform: "translate(-60.636 -242.783)",
    fill: "#495584",
    stroke: "#495584",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42378",
    "data-name": "Path 42378",
    d: "M249.533,256.143c-.509,0-1.018,0-1.528,0a.4.4,0,0,1-.435-.465c.03-.211.193-.334.456-.335.7,0,1.4,0,2.1,0,.307,0,.613,0,.92,0a.4.4,0,1,1,0,.8c-.5,0-1.006,0-1.509,0",
    transform: "translate(-235.367 -242.759)",
    fill: "#495584",
    stroke: "#495584",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42379",
    "data-name": "Path 42379",
    d: "M249.52,303.245c.5,0,1.006,0,1.509,0a.4.4,0,0,1,.446.366.385.385,0,0,1-.4.431q-1.564.009-3.129,0a.4.4,0,1,1,.006-.8c.521-.006,1.043,0,1.564,0",
    transform: "translate(-235.349 -288.302)",
    fill: "#495584",
    stroke: "#495584",
    strokeWidth: 0.3
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculator);
export default __webpack_public_path__ + "static/media/calculator.81713ade.svg";
export { ForwardRef as ReactComponent };